<template>
  <div class="demand_box">
    <div class="owner_title">录入金主需求</div>
    <div class="owner_box">
      <el-form
        ref="demandInfoForm"
        :rules="rules"
        :model="demandInfoForm"
        label-width="130px"
      >
        <el-form-item label="书名" prop="name">
          <el-input class="inpt_size" v-model="demandInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="金主给千字价格" prop="actual_cost">
          <el-input
            class="inpt_size"
            v-model="demandInfoForm.actual_cost"
          ></el-input>
        </el-form-item>
        <el-form-item label="给写手千字价格" prop="writer_cost">
          <el-input
            class="inpt_size"
            v-model="demandInfoForm.writer_cost"
          ></el-input>
        </el-form-item>
        <el-form-item label="每章字数" prop="each_chapter_num">
          <el-input
            class="inpt_size"
            v-model="demandInfoForm.each_chapter_num"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务要求" prop="ask">
          <el-input
            class="inpt_size textarea_ask"
            type="textarea"
            v-model="demandInfoForm.ask"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传需求文件">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :on-exceed="handleExceed"
            :on-change="fileChange"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            class="info_btn"
            type="primary"
            round
            @click="onSubmiOwnerDwmand"
            >确认录入</el-button
          >
          <el-button class="info_btn" type="info" plain round @click="goBack"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { upload_file } from "@/utils/api";
import { add_demand } from "@/utils/owner";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      connection_id: "", //金主id
      connection_expand_id: "", //金主扩展id-金主列表获取
      file_list: [], //上传文件路径
      isFile: false, //是否上传文件
      demandInfoForm: {
        departmentuser_id: "", //所属金主部id
        connection_id: "", //金主id
        connection_expand_id: "", //金主扩展id-金主列表获取
        name: "", //文章名称
        actual_cost: "", //实际每千字/费用
        writer_cost: "", //写手每千字/费用
        each_chapter_num: "", //每章字数
        ask: "", //任务要求
        file: "" //需求文件
      },
      rules: {
        name: { required: true, trigger: "blur", message: "书名不能为空" },
        actual_cost: [
          {
            required: true,
            trigger: "blur",
            message: "金主给的千字价格不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "价格只能为数字" }
        ],
        writer_cost: [
          {
            required: true,
            trigger: "blur",
            message: "给写手千字价格不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "价格只能为数字" }
        ],
        each_chapter_num: [
          { required: true, trigger: "blur", message: "每章字数不能为空" },
          {
            pattern: /^[0-9]*$/,
            trigger: "blur",
            message: "每章字数只能为数字"
          }
        ],
        ask: { required: true, trigger: "blur", message: "任务要求不能为空" }
      }
    };
  },
  created() {
    this.connection_id = this.$route.query.connection_id;
    this.connection_expand_id = this.$route.query.connection_expand_id;
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
  },
  methods: {
    // 表单提交
    onSubmiOwnerDwmand() {
      var that = this;
      that.demandInfoForm.departmentuser_id = that.ownerId;
      that.demandInfoForm.connection_id = that.connection_id;
      that.demandInfoForm.connection_expand_id = that.connection_expand_id;
      if (that.isFile == true) {
        var file_url = that.file_list[0].response.data.url;
        that.demandInfoForm.file = file_url;
      }

      let obj = {
        ...that.demandInfoForm
      };
      //录入金主信息
      add_demand(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.$router.push("/myOwner");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    fileChange(file, fileList) {
      var that = this;
      that.isFile = true;
      that.file_list = fileList;
    },
    //   取消返回首页
    goBack() {
      var that = this;
      that.$router.push("/myOwner");
    },
    // 文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 文件限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 文件删除之前
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.demand_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.owner_box {
  padding: 45px 30px;
}
.owner_box .el-form-item__label {
  width: 135px !important;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
.textarea_ask {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerDemand.vue